<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import ResetFeedbackMessage from "@/components/ResetFeedbackMessage.vue";

export default {
  name: "ResetFeedback",
  title: "Password recovery email sent",
  page: {
    title: "Forgot Password",
    meta: [{ name: "description", content: "Forgot Password" }],
  },
  props: {
    customerEmail: { type: String },
  },
  data() {
    return {
      theCustomerEmail: this.customerEmail,
    };
  },
  components: {
    Header,
    Footer,
    ResetFeedbackMessage,
  },
};
</script>
<template>
  <main>
    <Header />
    <div class="content">
      <ResetFeedbackMessage :customerEmail="theCustomerEmail" :here="'login'"/>
    </div>
    <Footer />
  </main>
</template>
<style scoped lang="scss">
.content {
  padding-bottom: 6%;

  display: flex;
  justify-content: center;
}
</style>